(function () {
    'use strict';

    angular
        .module('homeMyTasksControllers')
        .controller('MyTasksBIAProfileMgmtController', Controller);

    Controller.$inject = ['$scope', '$state', 'biaBuOwnerService'];

    function Controller($scope, $state, biaBuOwnerService) {
        $scope.tasksCountByName.biaProfilesToValidate = 0;

        // Get nb tasks for BU Owner Head
        biaBuOwnerService
            .getBIAProfilesToValidateByBUOwnerHead()
            .then(function (profilesToValidate) {
                $scope.biaProfilesToValidateByBUOwner = profilesToValidate;
                $scope.tasksCountByName.biaProfilesToValidate += profilesToValidate.length;
            });

        // Get nb tasks for BCC
        biaBuOwnerService
            .getBIAProfilesToValidateByBusinessContinuityCoordinator()
            .then(function (profilesToValidate) {
                $scope.biaProfilesToValidateBuBCCoordinator = profilesToValidate;
                $scope.tasksCountByName.biaProfilesToValidate += profilesToValidate.length;
            });

        $scope.withTasks = function () {
            return $scope.tasksCountByName.biaProfilesToValidate > 0;
        };

        // Go To BIA Profile to Validate
        $scope.goToBIAProfileToValidate = function (biaProfile) {
            $state.go('biaProfileSummary', { BIAProfileID: biaProfile.BIAProfileID });
        };

        // Go To BIA Profile
        $scope.goToBIAProfile = function (biaProfile) {
            $state.go('biaProfile.edit', { BIAProfileID: biaProfile.BIAProfileID });
        };
    }
})();